/* ═══════════════════════════════════════════════════════════════
   Gallery Lookbook – JS
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var TABLET_BP = 1024;

  function isTablet() {
    return window.innerWidth <= TABLET_BP;
  }

  /* ─── Apply desktop or mobile positions to dots & cards ─────────── */
  function applyPositions(section) {
    var mobile = isTablet();
    var xKey = mobile ? 'mobileX' : 'desktopX';
    var yKey = mobile ? 'mobileY' : 'desktopY';

    section.querySelectorAll('.gallery-lookbook__dot').forEach(function (dot) {
      var x = dot.dataset[xKey];
      var y = dot.dataset[yKey];
      if (x !== undefined) dot.style.left = x + '%';
      if (y !== undefined) dot.style.top  = y + '%';
    });

    section.querySelectorAll('.gallery-lookbook__card').forEach(function (card) {
      var x = card.dataset[xKey];
      var y = card.dataset[yKey];
      if (x !== undefined) card.style.left = x + '%';
      if (y !== undefined) card.style.top  = y + '%';
    });
  }

  /* ─── Clamp card positions so they stay within the slide bounds ─── */
  function clampMobileCards(section) {
    if (!isTablet()) return;

    section.querySelectorAll('.gallery-lookbook__slide').forEach(function (slide) {
      var slideW = slide.offsetWidth;
      var slideH = slide.offsetHeight;
      if (!slideW || !slideH) return;

      slide.querySelectorAll('.gallery-lookbook__card').forEach(function (card) {
        var cardW = card.offsetWidth;
        var cardH = card.offsetHeight;
        if (!cardW || !cardH) return;

        var leftPx = parseFloat(card.style.left) / 100 * slideW;
        var topPx  = parseFloat(card.style.top)  / 100 * slideH;

        var pad = 6;
        var clampedLeft = Math.max(pad, Math.min(leftPx, slideW - cardW - pad));
        var clampedTop  = Math.max(pad, Math.min(topPx,  slideH - cardH - pad));

        card.style.left = (clampedLeft / slideW * 100) + '%';
        card.style.top  = (clampedTop  / slideH * 100) + '%';
      });
    });
  }

  /* ─── Draw SVG connection lines between dots and cards ────────────── */
  function drawConnections(section) {
    section.querySelectorAll('.gallery-lookbook__slide').forEach(function (slide) {
      var svg = slide.querySelector('.gallery-lookbook__svg');
      if (!svg) return;

      /* Clear previous lines and paths */
      svg.querySelectorAll('line, path').forEach(function (l) { l.remove(); });

      /* Use actual slide dimensions for the viewBox so lines align on all breakpoints */
      var slideRect = slide.getBoundingClientRect();
      var VW = slideRect.width || 1097;
      var VH = slideRect.height || 701;
      svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);

      var dots  = slide.querySelectorAll('.gallery-lookbook__dot');
      var cards = slide.querySelectorAll('.gallery-lookbook__card');

      cards.forEach(function (card) {
        var mi = parseInt(card.dataset.markerIndex, 10);
        var dot = dots[mi];
        if (!dot) return;

        var dotX = parseFloat(dot.style.left) / 100;
        var dotY = parseFloat(dot.style.top) / 100;

        var dCx = dotX * VW;
        var dCy = dotY * VH;

        /* Compute card center using actual rendered size */
        var cardRect = card.getBoundingClientRect();
        var cW = cardRect.width;
        var cH = cardRect.height;
        var cLeft = parseFloat(card.style.left) / 100 * VW;
        var cTop  = parseFloat(card.style.top)  / 100 * VH;
        var cCx = cLeft + cW / 2;
        var cCy = cTop + cH / 2;

        /* Read line style and inverse flag from the dot's data attributes */
        var lineStyle = dot.dataset.lineStyle || 'straight';
        var inverseCurve = dot.dataset.inverseCurve === 'true';

        var NS = 'http://www.w3.org/2000/svg';

        if (lineStyle === 'straight') {
          var line = document.createElementNS(NS, 'line');
          line.setAttribute('x1', dCx);
          line.setAttribute('y1', dCy);
          line.setAttribute('x2', cCx);
          line.setAttribute('y2', cCy);
          svg.appendChild(line);
        } else {
          /* Curved lines using quadratic bezier */
          var midX = (dCx + cCx) / 2;
          var midY = (dCy + cCy) / 2;
          var dx = cCx - dCx;
          var dy = cCy - dCy;
          var len = Math.sqrt(dx * dx + dy * dy);
          /* Perpendicular offset for the control point */
          var nx = -dy / len;
          var ny = dx / len;
          /* Flip the perpendicular direction when inverse is enabled */
          var sign = inverseCurve ? -1 : 1;
          var curvature = lineStyle === 'curve_soft' ? 0.2 : 0.4;
          var cpX = midX + sign * nx * len * curvature;
          var cpY = midY + sign * ny * len * curvature;

          var path = document.createElementNS(NS, 'path');
          path.setAttribute('d', 'M ' + dCx + ' ' + dCy + ' Q ' + cpX + ' ' + cpY + ' ' + cCx + ' ' + cCy);
          path.setAttribute('fill', 'none');
          path.setAttribute('stroke', 'rgba(255, 255, 255, 0.65)');
          path.setAttribute('stroke-width', '1.5');
          svg.appendChild(path);
        }
      });
    });
  }

  /* ═══════════════════════════════════════════
     DESKTOP
  ═══════════════════════════════════════════ */
  function initDesktop(section) {
    var list     = section.querySelector('.gallery-lookbook__list');
    var navItems = section.querySelectorAll('.gallery-lookbook__nav-item');
    var slides   = section.querySelectorAll('.gallery-lookbook__slide');

    // Remove tablet wrappers if present
    var inner = section.querySelector('.gallery-lookbook__inner');
    if (inner) {
      while (inner.firstChild) section.appendChild(inner.firstChild);
      inner.remove();
    }
    var viewport = list.querySelector('.gallery-lookbook__viewport');
    if (viewport) {
      var track = viewport.querySelector('.gallery-lookbook__track');
      if (track) {
        while (track.firstChild) {
          list.appendChild(track.firstChild);
        }
      }
      viewport.remove();
    }
    /* Remove Swiper container if leftover from tablet mode */
    var swiperEl = list.querySelector('.swiper');
    if (swiperEl) {
      var swiperWrapper = swiperEl.querySelector('.swiper-wrapper');
      if (swiperWrapper) {
        Array.from(swiperWrapper.querySelectorAll('.gallery-lookbook__slide')).forEach(function (s) {
          s.classList.remove('swiper-slide', 'swiper-slide-active',
            'swiper-slide-prev', 'swiper-slide-next');
          list.appendChild(s);
        });
      }
      swiperEl.remove();
    }
    /* Remove pagination element if leftover */
    var paginationLeftover = list.querySelector('.gallery-lookbook__pagination');
    if (paginationLeftover) paginationLeftover.remove();
    slides = section.querySelectorAll('.gallery-lookbook__slide');

    section.style.height = '';
    list.style.height = '';

    if (slides.length > 0) slides[0].classList.add('is-active');

    /* Apply desktop positions */
    applyPositions(section);

    function updateActive() {
      var bestIdx = -1, bestDist = Infinity;
      slides.forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2;
        var vpCenter = window.innerHeight / 2;
        var dist = Math.abs(center - vpCenter);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      });
      if (bestIdx !== -1) {
        slides.forEach(function (el, i) { el.classList.toggle('is-active', i === bestIdx); });
        navItems.forEach(function (el, i) { el.classList.toggle('is-active', i === bestIdx); });
      }
    }

    var observer = new IntersectionObserver(function () {
      updateActive();
    }, {
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
    });
    slides.forEach(function (el) { observer.observe(el); });

    var rafId = null;
    function onScroll() {
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        updateActive();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    navItems.forEach(function (item, i) {
      item.addEventListener('click', function () {
        if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    drawConnections(section);

    return function cleanup() {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }

  /* ═══════════════════════════════════════════
     TABLET – Swiper.js carousel
  ═══════════════════════════════════════════ */
  function initTablet(section) {
    var list = section.querySelector('.gallery-lookbook__list');
    var slides = Array.from(list.querySelectorAll('.gallery-lookbook__slide'));

    if (slides.length === 0) return function () {};

    /* ── Clean up any leftover wrappers from previous modes ── */
    var inner = section.querySelector('.gallery-lookbook__inner');
    if (inner) {
      while (inner.firstChild) section.appendChild(inner.firstChild);
      inner.remove();
    }
    var oldViewport = list.querySelector('.gallery-lookbook__viewport');
    if (oldViewport) {
      var oldTrack = oldViewport.querySelector('.gallery-lookbook__track');
      if (oldTrack) { while (oldTrack.firstChild) list.appendChild(oldTrack.firstChild); }
      oldViewport.remove();
    }

    /* Re-query slides after cleanup (they may have moved) */
    slides = Array.from(list.querySelectorAll('.gallery-lookbook__slide'));

    /* Apply mobile positions before Swiper init */
    applyPositions(section);

    /* ── Build Swiper DOM: .swiper > .swiper-wrapper > .swiper-slide ── */
    var swiperContainer = list.querySelector('.swiper');
    var paginationEl = list.querySelector('.gallery-lookbook__pagination');

    if (!swiperContainer) {
      swiperContainer = document.createElement('div');
      swiperContainer.className = 'swiper gallery-lookbook__swiper';

      var wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';

      slides.forEach(function (slide) {
        slide.classList.add('swiper-slide');
        wrapper.appendChild(slide);
      });

      swiperContainer.appendChild(wrapper);
      list.appendChild(swiperContainer);

      /* Pagination dots — placed OUTSIDE swiper container to avoid
         Swiper's default absolute positioning and theme conflicts */
      paginationEl = document.createElement('div');
      paginationEl.className = 'swiper-pagination gallery-lookbook__pagination';
      list.appendChild(paginationEl);
    }

    /* ── Initialize Swiper ── */
    var swiper = new Swiper(swiperContainer, {
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 12,
      grabCursor: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        601: {
          spaceBetween: 16,
        },
      },
      on: {
        init: function () {
          updateActiveSlide(this.activeIndex);
          /* Clamp after a short delay so cards have rendered dimensions */
          setTimeout(function () {
            clampMobileCards(section);
            drawConnections(section);
          }, 50);
        },
        slideChange: function () {
          updateActiveSlide(this.activeIndex);
        },
      },
    });

    function updateActiveSlide(idx) {
      var allSlides = swiperContainer.querySelectorAll('.gallery-lookbook__slide');
      allSlides.forEach(function (el, i) {
        el.classList.toggle('is-active', i === idx);
      });
    }

    section.style.height = '';
    list.style.height = '';

    return function cleanup() {
      /* Destroy Swiper instance */
      if (swiper && swiper.destroy) {
        swiper.destroy(true, true);
      }

      /* Unwrap slides from Swiper DOM back into list */
      var wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (wrapper) {
        var swiperSlides = Array.from(wrapper.querySelectorAll('.gallery-lookbook__slide'));
        swiperSlides.forEach(function (slide) {
          slide.classList.remove('swiper-slide', 'swiper-slide-active',
            'swiper-slide-prev', 'swiper-slide-next');
          list.appendChild(slide);
        });
      }

      /* Remove swiper container + pagination */
      if (swiperContainer.parentNode) {
        swiperContainer.parentNode.removeChild(swiperContainer);
      }
      if (paginationEl && paginationEl.parentNode) {
        paginationEl.parentNode.removeChild(paginationEl);
      }
    };
  }

  /* ═══════════════════════════════════════════
     Layout Manager (per section instance)
  ═══════════════════════════════════════════ */
  function initGalleryLookbook(section) {
    var currentCleanup = null;
    var currentMode    = null;

    function init() {
      var mode = isTablet() ? 'tablet' : 'desktop';
      if (mode === currentMode) return;
      currentMode = mode;
      if (currentCleanup) currentCleanup();
      currentCleanup = mode === 'desktop' ? initDesktop(section) : initTablet(section);
    }

    init();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(init, 150);
    });
  }

  /* ─── Boot all instances on the page ─────────────────────────────── */
  document.querySelectorAll('.gallery-lookbook').forEach(initGalleryLookbook);
})();